// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1ZG7d","label":"CategoryService_label__21ZkJ","location":"CategoryService_location__UZ5Lr"};